var cov_28fkorxrul = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Grid/index.tsx",
      hash = "af6c02b49d06e3f7869e488c2113dfd27716dbc6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Grid/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 83
        },
        end: {
          line: 12,
          column: 93
        }
      },
      "1": {
        start: {
          line: 14,
          column: 20
        },
        end: {
          line: 14,
          column: 21
        }
      },
      "2": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 15,
          column: 23
        }
      },
      "3": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 21,
          column: 6
        }
      },
      "4": {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 20,
          column: 7
        }
      },
      "5": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 19,
          column: 27
        }
      },
      "6": {
        start: {
          line: 18,
          column: 31
        },
        end: {
          line: 18,
          column: 63
        }
      },
      "7": {
        start: {
          line: 19,
          column: 13
        },
        end: {
          line: 19,
          column: 27
        }
      },
      "8": {
        start: {
          line: 23,
          column: 22
        },
        end: {
          line: 23,
          column: 71
        }
      },
      "9": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 94
        }
      },
      "10": {
        start: {
          line: 27,
          column: 18
        },
        end: {
          line: 27,
          column: 53
        }
      },
      "11": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "12": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 26
        }
      },
      "13": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 29
        }
      },
      "14": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 46
        }
      },
      "15": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 47
        }
      },
      "16": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      "17": {
        start: {
          line: 38,
          column: 10
        },
        end: {
          line: 47,
          column: 11
        }
      },
      "18": {
        start: {
          line: 39,
          column: 72
        },
        end: {
          line: 39,
          column: 119
        }
      },
      "19": {
        start: {
          line: 40,
          column: 12
        },
        end: {
          line: 40,
          column: 57
        }
      },
      "20": {
        start: {
          line: 40,
          column: 36
        },
        end: {
          line: 40,
          column: 57
        }
      },
      "21": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 88
        }
      },
      "22": {
        start: {
          line: 41,
          column: 25
        },
        end: {
          line: 41,
          column: 88
        }
      },
      "23": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 44,
          column: 13
        }
      },
      "24": {
        start: {
          line: 43,
          column: 14
        },
        end: {
          line: 43,
          column: 93
        }
      },
      "25": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 46,
          column: 43
        }
      },
      "26": {
        start: {
          line: 48,
          column: 10
        },
        end: {
          line: 48,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 11
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 39
          },
          end: {
            line: 16,
            column: 40
          }
        },
        loc: {
          start: {
            line: 16,
            column: 86
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 40
          },
          end: {
            line: 37,
            column: 41
          }
        },
        loc: {
          start: {
            line: 37,
            column: 87
          },
          end: {
            line: 49,
            column: 9
          }
        },
        line: 37
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 12
          },
          end: {
            line: 12,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 12,
            column: 20
          },
          end: {
            line: 12,
            column: 21
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 20,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 20,
            column: 7
          }
        }, {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 20,
            column: 7
          }
        }],
        line: 17
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 10
          },
          end: {
            line: 17,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 10
          },
          end: {
            line: 17,
            column: 20
          }
        }, {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 41
          }
        }],
        line: 17
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 19,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 19,
            column: 27
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 22
          },
          end: {
            line: 23,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 38
          },
          end: {
            line: 23,
            column: 67
          }
        }, {
          start: {
            line: 23,
            column: 70
          },
          end: {
            line: 23,
            column: 71
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }],
        line: 28
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 14
          }
        }, {
          start: {
            line: 28,
            column: 18
          },
          end: {
            line: 28,
            column: 28
          }
        }],
        line: 28
      },
      "7": {
        loc: {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 47,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 47,
            column: 11
          }
        }, {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 47,
            column: 11
          }
        }],
        line: 38
      },
      "8": {
        loc: {
          start: {
            line: 38,
            column: 14
          },
          end: {
            line: 38,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 14
          },
          end: {
            line: 38,
            column: 24
          }
        }, {
          start: {
            line: 38,
            column: 28
          },
          end: {
            line: 38,
            column: 45
          }
        }],
        line: 38
      },
      "9": {
        loc: {
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 57
          }
        }, {
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 57
          }
        }],
        line: 40
      },
      "10": {
        loc: {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 41,
            column: 88
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 41,
            column: 88
          }
        }, {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 41,
            column: 88
          }
        }],
        line: 41
      },
      "11": {
        loc: {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 44,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 44,
            column: 13
          }
        }, {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 44,
            column: 13
          }
        }],
        line: 42
      },
      "12": {
        loc: {
          start: {
            line: 42,
            column: 16
          },
          end: {
            line: 42,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 16
          },
          end: {
            line: 42,
            column: 22
          }
        }, {
          start: {
            line: 42,
            column: 26
          },
          end: {
            line: 42,
            column: 36
          }
        }],
        line: 42
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Grid/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, Children, cloneElement } from 'react';
import classnames from 'classnames';
import { getGrid } from './utils';

var Grid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Grid, _PureComponent);

  var _super = _createSuper2(Grid);

  function Grid() {
    _classCallCheck(this, Grid);

    return _super.apply(this, arguments);
  }

  _createClass(Grid, [{
    key: "render",
    value: function render() {
      cov_28fkorxrul.f[0]++;

      var _ref = (cov_28fkorxrul.s[0]++, this.props),
          _ref$width = _ref.width,
          width = _ref$width === void 0 ? (cov_28fkorxrul.b[0][0]++, 1) : _ref$width,
          offset = _ref.offset,
          responsive = _ref.responsive,
          stretch = _ref.stretch,
          children = _ref.children,
          gutter = _ref.gutter,
          other = _objectWithoutProperties(_ref, ["width", "offset", "responsive", "stretch", "children", "gutter"]);

      var autoCount = (cov_28fkorxrul.s[1]++, 0);
      var settleWidth = (cov_28fkorxrul.s[2]++, 0);
      cov_28fkorxrul.s[3]++;
      Children.toArray(children).forEach(function (child) {
        cov_28fkorxrul.f[1]++;
        cov_28fkorxrul.s[4]++;

        if ((cov_28fkorxrul.b[2][0]++, child.type) && (cov_28fkorxrul.b[2][1]++, child.type.isGrid)) {
          cov_28fkorxrul.b[1][0]++;
          cov_28fkorxrul.s[5]++;

          if (child.props.width) {
            cov_28fkorxrul.b[3][0]++;
            cov_28fkorxrul.s[6]++;
            settleWidth += child.props.width;
          } else {
            cov_28fkorxrul.b[3][1]++;
            cov_28fkorxrul.s[7]++;
            autoCount += 1;
          }
        } else {
          cov_28fkorxrul.b[1][1]++;
        }
      });
      var autoWidth = (cov_28fkorxrul.s[8]++, autoCount > 0 ? (cov_28fkorxrul.b[4][0]++, (1 - settleWidth) / autoCount) : (cov_28fkorxrul.b[4][1]++, 0));
      var className = (cov_28fkorxrul.s[9]++, classnames(this.props.className, getGrid({
        width: width,
        offset: offset,
        responsive: responsive
      })));
      var style = (cov_28fkorxrul.s[10]++, Object.assign({}, this.props.style));
      cov_28fkorxrul.s[11]++;

      if ((cov_28fkorxrul.b[6][0]++, gutter) && (cov_28fkorxrul.b[6][1]++, gutter > 0)) {
        cov_28fkorxrul.b[5][0]++;
        cov_28fkorxrul.s[12]++;
        style.width = 'auto';
        cov_28fkorxrul.s[13]++;
        style.display = 'block';
        cov_28fkorxrul.s[14]++;
        style.marginLeft = "".concat(0 - gutter / 2, "px");
        cov_28fkorxrul.s[15]++;
        style.marginRight = "".concat(0 - gutter / 2, "px");
      } else {
        cov_28fkorxrul.b[5][1]++;
      }

      cov_28fkorxrul.s[16]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, other, {
          style: style,
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 36,
            columnNumber: 7
          }
        }), Children.toArray(children).map(function (child) {
          cov_28fkorxrul.f[2]++;
          cov_28fkorxrul.s[17]++;

          if ((cov_28fkorxrul.b[8][0]++, child.type) && (cov_28fkorxrul.b[8][1]++, child.type.isGrid)) {
            cov_28fkorxrul.b[7][0]++;
            var pps = (cov_28fkorxrul.s[18]++, {
              style: Object.assign({}, child.props.style)
            });
            cov_28fkorxrul.s[19]++;

            if (!child.props.width) {
              cov_28fkorxrul.b[9][0]++;
              cov_28fkorxrul.s[20]++;
              pps.width = autoWidth;
            } else {
              cov_28fkorxrul.b[9][1]++;
            }

            cov_28fkorxrul.s[21]++;

            if (stretch) {
              cov_28fkorxrul.b[10][0]++;
              cov_28fkorxrul.s[22]++;
              pps.style = _objectSpread2(_objectSpread2({}, pps.style), {}, {
                minHeight: '100%',
                height: '100%'
              });
            } else {
              cov_28fkorxrul.b[10][1]++;
            }

            cov_28fkorxrul.s[23]++;

            if ((cov_28fkorxrul.b[12][0]++, gutter) && (cov_28fkorxrul.b[12][1]++, gutter > 0)) {
              cov_28fkorxrul.b[11][0]++;
              cov_28fkorxrul.s[24]++;
              pps.style = _objectSpread2(_objectSpread2({}, pps.style), {}, {
                paddingLeft: gutter / 2,
                paddingRight: gutter / 2
              });
            } else {
              cov_28fkorxrul.b[11][1]++;
            }

            cov_28fkorxrul.s[25]++;
            return (
              /*#__PURE__*/
              cloneElement(child, pps)
            );
          } else {
            cov_28fkorxrul.b[7][1]++;
          }

          cov_28fkorxrul.s[26]++;
          return child;
        }))
      );
    }
  }]);

  return Grid;
}(PureComponent);

Grid.isGrid = true;
Grid.displayName = 'ShineoutGrid';
export { Grid as default };